const { API_URL } = process.env;
export const axios = require("axios");

export const remove_model = async (uid) => {
  axios.defaults.baseURL = API_URL;
  const res = await axios.get("/removeModel", {
    params: {
      modelID: uid,
    },
  });
  const { data } = res;
};

export const remove_model_img = async (uid, imgId) => {
  axios.defaults.baseURL = API_URL;
  const res = await axios.get("/removeModelImage", {
    params: {
      modelID: uid,
      imageID: imgId,
    },
  });
  const { data } = res;
};

export const process_model = async (uid, imgId) => {
  axios.defaults.baseURL = API_URL;
  const res = await axios.get(
    "https://faceswap.prismatec.co.jp/preprocessModel",
    {
      params: {
        modelID: uid,
        imageID: imgId,
      },
    }
  );
  const { data } = res;
};
